$(document).ready(function(){
  getProductsSale();
  GetRandomActivePromotions();
});
function getProductsSale(){
  let DataSend = {
    'size':15
  }
  PostMethodFunction('/Home/Promotion/GetSaleProducts', DataSend, null , showProductsSale, null);
}
function showProductsSale(result){
  //console.log('showProductsBySale => ', result);
  let AppendContent = '';
  let brandsString = '';
  //for(let i=0; i<6; i++){
    $.each(result.data, function(index, product){
      AppendContent += '<li class="products-list-item mb-4 mt-0 p-0" onclick="location.href=\'/Product/'+product.url+'\'">';
        if(product.front_images != null && product.front_images.length > 0){
          //get random position of front images
          let randomPosition = Math.floor(Math.random() * product.front_images.length);
          AppendContent += '<div class="product-img" style="background-image: url(\'/'+product.front_images[randomPosition].path+'\')">';
          AppendContent += '</div>';
        }
        AppendContent += '<p class="product-name text-start">'+product.name+'</p>';
        //brands
        brandsString = '';
        $.each(product.brands, function(index, brand){
          brandsString += brand.name + ', ';
        });
        brandsString = brandsString.substring(0, brandsString.length - 2);
        if(brandsString != ''){
          AppendContent += '<p class="product-brand text-start">'+brandsString+'</p>';
        }
        //price
        AppendContent += '<p class="product-price text-start">$'+product.price.toLocaleString()+' USD</p>';
        //normal price
        if(product.normal_price != null && product.normal_price > 0){
          AppendContent += '<p class="product-normal-price text-start">$'+product.normal_price.toLocaleString()+' USD</p>';
        }
        
      AppendContent += '</li>';
    });  
  //}
  
  $('#product-list-sale').empty().append(AppendContent);
}
function GetRandomActivePromotions(){
  GetMethodFunction('/Home/Promotion/GetRandomActivePromotions', null, showRandomActivePromotions, null);
}
function showRandomActivePromotions(response){
  console.log('showRandomActivePromotions => ', response);
  let promotions =  response.data;
  if(promotions.length == 0){
    $('#promotion-container').remove();
    return;
  }
  let AppendContent = '';
  let promotion_img;
  $.each(promotions, function(index, promotion){
    promotion_img = promotion.image;
    AppendContent += '<li class="promotion-item d-flex justify-content-between" onclick="location.href=\'/Promotion/'+promotion.url+'\'">';
      AppendContent += '<div class="promotion-item-img" style="background-image: url(\'/storage/promotion/image/'+promotion_img+'\')"></div>';
      AppendContent += '<div class="promotion-item-text-container d-flex flex-column">';
        AppendContent += '<h4 class="promotion-text promotion-item-title">'+promotion.name+'</h4>';
        AppendContent += '<p class="promotion-text promotion-item-text">'+promotion.description+'</p>';
        AppendContent += '<p class="promotion-text promotion-item-discount align-self-end">'+promotion.discount+'%</p>';
        AppendContent += '</div>';
    AppendContent += '</li>';
  });
  $('#promotion-list').empty().append(AppendContent);
}